import { render, staticRenderFns } from "./boardChart.vue?vue&type=template&id=97bf5834&scoped=true&"
import script from "./boardChart.vue?vue&type=script&lang=js&"
export * from "./boardChart.vue?vue&type=script&lang=js&"
import style0 from "./boardChart.vue?vue&type=style&index=0&id=97bf5834&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97bf5834",
  null
  
)

export default component.exports